<div [ngClass]="{ 'csv-initial': currentStep === 'initial', 'csv-column-assignment': currentStep === 'column-assignment', 'csv-validation': currentStep === 'validation', 'csv-insert-completion': currentStep === 'insert-completion', 'csv-summary': currentStep === 'summary'}">
    
    <!-- Pasos 1 y 2. Descarga de plantilla e importación -->
    <ng-container *ngIf="currentStep === 'initial'">
        <div>
            <h4>{{ 'csv-import.export.title' | translate}}</h4>
            <p>{{ 'csv-import.export.p1' | translate }} <span>{{ getMainKeyword() | translate }}</span>.</p>
            <p>
                <span style="font-family: 'semibold';">{{ 'csv-import.important' | translate }}</span>
                {{ 'csv-import.export.p2Read' | translate }}
                <span style="text-decoration: underline" class="pseudolink" (click)="getSpecificationDoc()">{{ 'csv-import.export.p2Doc' | translate }}</span>
                {{ 'csv-import.export.p2Reg' | translate }}</p>
        </div>

        <div>
            <h4>{{ 'csv-import.import.title' | translate}} {{ getMainKeyword() | translate }}</h4>
            <p>{{ 'csv-import.import.p1' | translate }} <span>{{ getMainKeyword() | translate }}</span>.</p>
            <p>
                <span style="font-family: 'semibold';">{{ 'csv-import.important' | translate }}</span>
                {{ 'csv-import.import.p2' | translate }}
            </p>
            <p>
                {{ 'csv-import.import.p3Create' | translate }}
                {{ getSecondaryKeyword() | translate }}
                {{ 'csv-import.import.p3Form' | translate }}
                <span style="text-decoration: underline" class="pseudolink" (click)="closeModalAndOpenForm('open-form')">{{ 'csv-import.import.p3Here' | translate }}</span>
            </p>
        </div>

        <!-- Mantener este orden por ajuste del grid -->
        <button class="button-icon" (click)="downloadTemplate()">
            <i class="fas fa-circle-down"></i>
            {{ 'csv-import.export.button' | translate }}
        </button>

        <div>
            <button class="button-icon" (click)="openInputFile()">
                <i class="fas fa-circle-down" style="transform: rotate(180deg);"></i>
                {{ 'csv-import.import.button' | translate }}
            </button>
            <span style="text-decoration: underline" *ngIf="savedInputFile?.name">{{ 'csv-import.import.file' | translate }}: {{ savedInputFile?.name }}</span>
        </div>
        
        <div>
            <input #inputFile type="file" accept=".csv" hidden (change)="saveInputFile($event)"/>
            <button class="secondary" (click)="closeModalAndOpenForm('')">{{ 'global.cancelar' | translate }}</button>
            <button (click)="changeToColumnTitlesView()">{{ 'global.continuar' | translate }}</button>
        </div>
    </ng-container>

    <!-- Paso 3. Asignación de columnas -->
    <ng-container *ngIf="currentStep === 'column-assignment'">
        <h4>{{ 'csv-import.columnAssignment.title' | translate }}</h4>
        <p>{{ 'csv-import.columnAssignment.p1' | translate }}</p>
        <p style="font-family: 'medium'">{{ 'csv-import.columnAssignment.p2' | translate }} {{ totalColumnTitlesChecked }}/{{ columnAssignmentData.length }} {{ 'csv-import.columnAssignment.columns' | translate }}</p>
        <div class="table-wrapper" style="overflow-y: auto; max-height: 35rem;">
            <div class="table-container">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="text-align: center">{{ 'csv-import.columnAssignment.import' | translate }}</th>
                            <th style="text-align: left">{{ 'csv-import.columnAssignment.columnNameFile' | translate }}</th>
                            <th style="text-align: left">{{ 'csv-import.columnAssignment.relateTo' | translate }}</th>
                            <th style="text-align: left">{{ 'csv-import.columnAssignment.columnNameTemplate' | translate }}</th>
                            <th style="text-align: left">{{ 'csv-import.columnAssignment.preview' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let data of columnAssignmentData; let i = index" [formGroup]="columnAssignmentForm">
                        <tr>
                            <td style="text-align: center">
                                <div>
                                    <input type="checkbox" [id]="'col-check' + i" [formControlName]="getInputControlName(data.title) + 'Check'" (change)="updateCheckbox(data.title, $event.target.checked)">
                                    <label [for]="'col-check' + i"></label>
                                </div>
                            </td>
                            <td style="text-align: left" class="file-column-name">
                                <input name="title" type="text" [formControlName]="getInputControlName(data.title)">
                            </td>
                            <td style="text-align: left">
                                <div class="arrow">
                                    <span [ngClass]="{ 'row-disabled': getArrowDisabled(data.title) }"></span>
                                    <span [ngClass]="{ 'row-disabled': getArrowDisabled(data.title) }"></span>
                                    </div>
                            </td>
                            <td style="text-align: left">
                                <app-filterable-list class="short-ol" [itemsList]="templateTitles" [selectedItem]="getFilterableListControl(data.title)" [placeHolder]="false"></app-filterable-list>
                            </td>
                            <td style="text-align: left">
                                <div class="preview">
                                    <span>{{ data.preview1 }}</span>
                                    <span>{{ data.preview2 }}</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="button-group-between">
            <div (click)="goBack('initial')">
                <i class="fas fa-angle-left" style="color: #004434"></i>
                <p>{{ 'global.volver' | translate }}</p>
            </div>
            <div>
                <button class="secondary" (click)="closeModalAndOpenForm('')">{{ 'global.cancelar' | translate }}</button>
                <button (click)="uploadAndValidateCsv()">{{ 'global.continuar' | translate }}</button>
            </div>
        </div>
    </ng-container>

    <!-- Paso 4. Corrección de errores -->
    <ng-container *ngIf="currentStep === 'validation'">
        <h4>{{ 'csv-import.validation.title' | translate }}</h4>
        <p *ngIf="!noErrorsAfterCorrecting">{{ 'csv-import.validation.p1' | translate }}</p>
        <p style="font-family: 'medium'" *ngIf="!noErrorsAfterCorrecting">
            {{ validationData.length === 1 ? ('csv-import.validation.p2Singular' | translate) : ('csv-import.validation.p2Plural' | translate) }} {{ validationData.length }} 
            {{ validationData.length === 1 ? ('csv-import.record' | translate) : ('csv-import.records' | translate) }} 
            {{ 'csv-import.validation.p2Data' | translate }}</p>
        <p *ngIf="noErrorsAfterCorrecting">{{ 'csv-import.success.noErrors' | translate }}</p>

        <div class="table-wrapper" *ngIf="!noErrorsAfterCorrecting" style="overflow-y: auto; max-height: 14.5rem; margin-bottom: 1rem;">
            <div class="table-container">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="align-left" *ngFor="let title of validationTitles; let i = index" 
                                [ngStyle]="{ 'box-shadow': showTableHeaderIcon(i) ? 'inset 0 0 0 2px #dc2828' : ''}">
                                <div class="title-group">
                                    {{ title === 'ggn' ? (title | uppercase) : title[0].toUpperCase() + title.slice(1) }}
                                    <i *ngIf="showTableHeaderIcon(i)" class="fas fa-circle-info" style="color: #c14848; font-size: .85rem" [title]="'csv-import.errors.columnFormat' | translate"></i>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody [formGroup]="validationForm">
                        <tr *ngFor="let row of validationData; let i = index">
                            <td *ngFor="let data of row.values; let childI = index" 
                                (click)="showValidationInput(i, childI)" [ngStyle]="{ 'box-shadow': data[1] !== 'correct' ? 'inset 0 0 0 2px #dc2828' : ''}">
                                <div class="data-validated">
                                    <ng-container *ngIf="editValidationData !== i + ',' + childI">
                                        {{ data[0] }}
                                    </ng-container>
                                    <input #inputValidation class="subtle-input" *ngIf="editValidationData === i + ',' + childI" type="text" [size]="data[0]?.length - 1 || 1" formControlName="validationData">
                                    <i *ngIf="!showTableHeaderIcon(childI) && data[1] !== 'correct'" class="fas fa-circle-info" style="color: #c14848; font-size: .85rem" [title]="data[1]"></i>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
        <!-- TO-DO: también está la clase flex-end si no se permite actualizar -->
        <div class="checkbox-button-group" [formGroup]="validationForm" [ngStyle]="{ 'justify-content': noErrorsAfterCorrecting ? 'flex-start' : ''}">
            <div>
                <input type="checkbox" id="update-and-insert" [checked]="updateAndInsertInitialChecked" formControlName="updateAndInsert">
                <label for="update-and-insert">{{ 'csv-import.validation.update' | translate }}</label>
            </div>
            <button *ngIf="!noErrorsAfterCorrecting" class="secondary button-icon" (click)="correctValidationData()">
                <i class="far fa-save"></i>
                {{ 'global.guardarCambios' | translate }}
            </button>
        </div>

        <div class="button-group-between">
            <div (click)="goBack('column-assignment')">
                <i class="fas fa-angle-left" style="color: #004434"></i>
                <p>{{ 'global.volver' | translate }}</p>
            </div>
            <div>
                <button class="secondary" (click)="closeModalAndOpenForm('')">{{ 'global.cancelar' | translate }}</button>
                <button (click)="changeToInsertCompletion()">{{ 'global.continuar' | translate }}</button>
            </div>
        </div>
    </ng-container>

    <!-- Paso 5. Completar la importación -->
    <ng-container *ngIf="currentStep === 'insert-completion'">
        <h4>{{ 'csv-import.insertCompletion.title' | translate }}</h4>
        <!-- Registros a añadir o actualizar -->
        <p>
            <!-- TO-DO: modificar shipmentsIncoming por el nombre de la clave donde no se permita actualizar -->
            {{ mainKeyword === 'shipmentsIncoming' || !updateAndInsertInitialChecked ? getTotalRecords('insert-only') : getTotalRecords('insertAndUpdate') }}
        </p>
        <p>
            <span style="font-family: 'medium'">{{ 'csv-import.insertCompletion.p2' | translate }}</span>
            {{ savedInputFile?.name }}
        </p>
        <!-- Total de registros del fichero -->
        <p>
            <span style="font-family: 'medium'">{{ 'csv-import.insertCompletion.p3' | translate }}</span>
            {{ validationResponse?.numRegOk + validationResponse?.numRegError }}
        </p>
        <!-- A insertar -->
        <p>
            <span style="font-family: 'medium'">{{ 'csv-import.insertCompletion.p4' | translate }}</span>
            {{ validationResponse?.numRegIns }}
        </p>
        <!-- A actualizar -->
        <p>
            <span style="font-family: 'medium'">{{ 'csv-import.insertCompletion.p5' | translate }}</span>
            {{ mainKeyword === 'shipmentsIncoming' || !updateAndInsertInitialChecked ? 0 : validationResponse?.numRegUpd }}
        </p>
        <!-- Registros que NO se importarán -->
        <p>
            <span style="font-family: 'medium'">{{ 'csv-import.insertCompletion.p6' | translate }}</span>
            {{ mainKeyword === 'shipmentsIncoming' || !updateAndInsertInitialChecked ? validationResponse?.numRegError + validationResponse?.numRegUpd + (validationResponse?.numRegNoEditables || 0) : validationResponse?.numRegError + (validationResponse?.numRegNoEditables || 0) }}
        </p>
        <button class="button-icon" (click)="completeImport()">
            <i class="fas fa-circle-down" style="transform: rotate(180deg);"></i>
            {{ 'csv-import.insertCompletion.button' | translate }}
        </button>
        <div class="button-group-between">
            <div (click)="goBack('validation')">
                <i class="fas fa-angle-left" style="color: #004434"></i>
                <p>{{ 'global.volver' | translate }}</p>
            </div>
            <button class="secondary" (click)="closeModalAndOpenForm('')">{{ 'global.cancelar' | translate }}</button>
        </div>
    </ng-container>

    <!-- Resumen de la importación -->
    <ng-container *ngIf="currentStep === 'summary'">
        <h4>{{ 'csv-import.summary.title' | translate }}</h4>
        <p>{{ 'csv-import.summary.p1' | translate }} {{ savedInputFile?.name }}</p>
        <div>
            <i class="far fa-circle-check" style="color: #005ccc"></i>
            {{ insertCompletionResponse?.numRegIns === 1 ? '1 ' + ('csv-import.summary.newRecordsSingular' | translate) : (insertCompletionResponse?.numRegIns || 0) + ' ' + ('csv-import.summary.newRecordsPlural' | translate) }}
        </div>
        <div>
            <i class="far fa-circle-check" style="color: #2e9900"></i>
            {{ insertCompletionResponse?.numRegUpd === 1 ? '1 ' + ('csv-import.summary.updatedRecordsSingular' | translate) : (insertCompletionResponse?.numRegUpd || 0) + ' ' + ('csv-import.summary.updatedRecordsPlural' | translate) }}
        </div>
        <!-- Registros no importados -->
        <div>
            <!-- TO-DO: modificar shipmentsIncoming por el nombre de la clave donde no se permita actualizar -->
            <i class="far fa-circle-xmark" style="color: #e61717"></i>
            {{ mainKeyword === 'shipmentsIncoming' || !updateAndInsertInitialChecked ? validationResponse?.lsError?.length + (validationResponse?.numRegNoEditables || 0) + insertCompletionResponse?.numRegUpd : validationResponse?.lsError?.length + (validationResponse?.numRegNoEditables || 0) }}
            {{ ((mainKeyword === 'shipmentsIncoming' || !updateAndInsertInitialChecked) && (validationResponse?.lsError?.length + (validationResponse?.numRegNoEditables || 0) + insertCompletionResponse?.numRegUpd === 1)) 
            || ((mainKeyword !== 'shipmentsIncoming' && updateAndInsertInitialChecked) && (validationResponse?.lsError?.length + (validationResponse?.numRegNoEditables || 0) === 1)) ? ' ' + ('csv-import.summary.notImportedSingular' | translate) : ' ' + ('csv-import.summary.notImportedPlural' | translate) }}
        </div>

        <div class="button-group">
            <button class="secondary" (click)="closeModalAndOpenForm(refreshParentPage ? 'refresh-page' : '')">{{ 'global.cerrar' | translate }}</button>
        </div>
    </ng-container>
</div>

<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>